module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/@cerebral/react/index.js
// module id = 124
// module chunks = 0